import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IInvoiceFields {
		id?: any;
		jobCardId?: any;
		deviationReasonId?: any;
		dateSubmitted?: any;
		dateReturned?: any;
		replacementPONumber?: any;
		dateToBudgetOwner?: any;
		dateRequested?: any;
		dateRequesHonored?: any;
		planner?: any;
		dateProFormaSent?: any;
		dateInvoiceReceived?: any;
		invoiceNo?: any;
		creditNoteNo?: any;
		dateSesSubmitted?: any;
		dateSesSAccepted?: any;
		sesNo?: any;
		datePaymentExpected?: any;
		datePaymentReceived?: any;
		remittanceNo?: any;
		invoiceWorkFlowStatusId?: any;
		finalInvoice?: any;
		status?: any;
		datestamp?: any;
		changedBy?: any;
		amount?: any;
		headOfficeInvoiceNo?: any;
		headOfficeJobNo?: any;
		headOfficeInvoiceAmount?: any;
		invoiceStatusId?: any;
		headOfficeInvoiceWorkFlowStatusId?: any;
		invoicePeriodStart?: any;
		invoicePeriodEnd?: any;
		previousClaimsAmount?: any;
		requestTypeId?: any;
		dateInvoiceProcessed?: any;
}

export class InvoiceFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public jobCardId: IEntityModelField = { name: "jobCardId", displayName: "Job Card Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public deviationReasonId: IEntityModelField = { name: "deviationReasonId", displayName: "Deviation Reason Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public dateSubmitted: IEntityModelField = { name: "dateSubmitted", displayName: "Date Submitted", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateReturned: IEntityModelField = { name: "dateReturned", displayName: "Date Returned", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public replacementPONumber: IEntityModelField = { name: "replacementPONumber", displayName: "Replacement PONumber", fieldType: FieldType.String, pattern: "NameGeneric" };
	public dateToBudgetOwner: IEntityModelField = { name: "dateToBudgetOwner", displayName: "Date To Budget Owner", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateRequested: IEntityModelField = { name: "dateRequested", displayName: "Date Requested", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateRequesHonored: IEntityModelField = { name: "dateRequesHonored", displayName: "Date Reques Honored", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public planner: IEntityModelField = { name: "planner", displayName: "Planner", fieldType: FieldType.String, pattern: "NameGeneric" };
	public dateProFormaSent: IEntityModelField = { name: "dateProFormaSent", displayName: "Date Pro Forma Sent", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateInvoiceReceived: IEntityModelField = { name: "dateInvoiceReceived", displayName: "Date Invoice Received", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public invoiceNo: IEntityModelField = { name: "invoiceNo", displayName: "Invoice No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public creditNoteNo: IEntityModelField = { name: "creditNoteNo", displayName: "Credit Note No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public dateSesSubmitted: IEntityModelField = { name: "dateSesSubmitted", displayName: "Date Ses Submitted", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public dateSesSAccepted: IEntityModelField = { name: "dateSesSAccepted", displayName: "Date Ses SAccepted", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public sesNo: IEntityModelField = { name: "sesNo", displayName: "Ses No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public datePaymentExpected: IEntityModelField = { name: "datePaymentExpected", displayName: "Date Payment Expected", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public datePaymentReceived: IEntityModelField = { name: "datePaymentReceived", displayName: "Date Payment Received", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public remittanceNo: IEntityModelField = { name: "remittanceNo", displayName: "Remittance No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public invoiceWorkFlowStatusId: IEntityModelField = { name: "invoiceWorkFlowStatusId", displayName: "Invoice Work Flow Status Id", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public finalInvoice: IEntityModelField = { name: "finalInvoice", displayName: "Final Invoice", fieldType: FieldType.Byte, pattern: "NameGeneric" };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric" };
	public amount: IEntityModelField = { name: "amount", displayName: "Amount", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public headOfficeInvoiceNo: IEntityModelField = { name: "headOfficeInvoiceNo", displayName: "Head Office Invoice No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public headOfficeJobNo: IEntityModelField = { name: "headOfficeJobNo", displayName: "Head Office Job No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public headOfficeInvoiceAmount: IEntityModelField = { name: "headOfficeInvoiceAmount", displayName: "Head Office Invoice Amount", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public invoiceStatusId: IEntityModelField = { name: "invoiceStatusId", displayName: "Invoice Status Id", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public headOfficeInvoiceWorkFlowStatusId: IEntityModelField = { name: "headOfficeInvoiceWorkFlowStatusId", displayName: "Head Office Invoice Work Flow Status Id", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public invoicePeriodStart: IEntityModelField = { name: "invoicePeriodStart", displayName: "Invoice Period Start", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public invoicePeriodEnd: IEntityModelField = { name: "invoicePeriodEnd", displayName: "Invoice Period End", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public previousClaimsAmount: IEntityModelField = { name: "previousClaimsAmount", displayName: "Previous Claims Amount", fieldType: FieldType.Float, pattern: "NameGeneric" };
	public requestTypeId: IEntityModelField = { name: "requestTypeId", displayName: "Request Type Id", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public dateInvoiceProcessed: IEntityModelField = { name: "dateInvoiceProcessed", displayName: "Date Invoice Processed", fieldType: FieldType.DateTime, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.jobCardId);
		this.push(this.deviationReasonId);
		this.push(this.dateSubmitted);
		this.push(this.dateReturned);
		this.push(this.replacementPONumber);
		this.push(this.dateToBudgetOwner);
		this.push(this.dateRequested);
		this.push(this.dateRequesHonored);
		this.push(this.planner);
		this.push(this.dateProFormaSent);
		this.push(this.dateInvoiceReceived);
		this.push(this.invoiceNo);
		this.push(this.creditNoteNo);
		this.push(this.dateSesSubmitted);
		this.push(this.dateSesSAccepted);
		this.push(this.sesNo);
		this.push(this.datePaymentExpected);
		this.push(this.datePaymentReceived);
		this.push(this.remittanceNo);
		this.push(this.invoiceWorkFlowStatusId);
		this.push(this.finalInvoice);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.amount);
		this.push(this.headOfficeInvoiceNo);
		this.push(this.headOfficeJobNo);
		this.push(this.headOfficeInvoiceAmount);
		this.push(this.invoiceStatusId);
		this.push(this.headOfficeInvoiceWorkFlowStatusId);
		this.push(this.invoicePeriodStart);
		this.push(this.invoicePeriodEnd);
		this.push(this.previousClaimsAmount);
		this.push(this.requestTypeId);
		this.push(this.dateInvoiceProcessed);
	}
}

export class InvoiceDTO implements IEntityModel {
	protected invoiceName: string = "InvoiceModel";
	protected invoiceKeyField: string = "id";
	protected invoiceDisplayName: string = "Invoice|Invoices";
	protected invoiceFields = new InvoiceFields();
	public get name(): string { return this.invoiceName };
	public get keyField(): string { return this.invoiceKeyField };
	public get displayName(): string { return this.invoiceDisplayName };
	public get fields(): InvoiceFields { return this.invoiceFields };

	constructor() {};
}
